import React from "react";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { withStyles } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";
import Grid from "@material-ui/core/Grid";

import BaseMapView, { styles } from "../../views/global_cockpits/BaseMapView";

@withStyles(styles)
@observer
class SupplyMapView extends BaseMapView {
  static apiSubPath = "/supply_map/";

  title = "Supply map";
  markerVariant = "rect";

  @observable sfg = false;
  @observable kpi = "quantity";
  @observable granularity = "factory";

  createSwitches() {
    this.switches = null;
  }

  _setData(data) {
    super._setData(data);
    this.sfg = data.sfg === "true";
  }

  _getQueryParams() {
    return {
      ...super._getQueryParams(),
      sfg: this.sfg,
    };
  }

  get kpiChoices() {
    return [
      { value: "quantity", display_name: "Quantity" },
      { value: "capacity_utilization", display_name: "Capacity utilization" },
      { value: "active_vs_max", display_name: "Active Vs Max Capacity" },
      { value: "below_min_stock", display_name: "Stock below min" },
      { value: "above_max_stock", display_name: "Stock above max" },
      { value: "availability_fg", display_name: "FG sales coverage" },
      ...super.kpiChoices,
    ];
  }

  get granularityChoices() {
    return [
      { value: "factory", display_name: "Factory" },
      { value: "factoryXTechno", display_name: "Factory X Technology" },
      ...super.granularityChoices,
    ];
  }

  isRatioKpi(kpiName) {
    return (
      kpiName === "capacity_utilization" ||
      kpiName === "availability_fg" ||
      kpiName === "active_vs_max"
    );
  }

  get granularTable() {
    if (this.region === null) {
      return this.data.region_table;
    }
    if (this.granularity === "factory") {
      return this.data.factory_table;
    }
    if (this.granularity === "factoryXTechno") {
      return this.data.factory_x_techno_table;
    }
    return this.data.techno_table;
  }

  onSfgChange = this.genericToggleHandler("sfg");

  get extraControls() {
    return (
      <Grid item>
        FG
        <Switch checked={this.sfg} onChange={this.onSfgChange} />
        SFG
      </Grid>
    );
  }
}

export default SupplyMapView;
